import React, { createContext, useCallback, useState, useContext, useEffect } from 'react';
import {createGlobalStyle, css} from 'styled-components';
import { useSocket } from './Socket';
import Axios from 'axios';


interface PlatformState {
  token: string;
  user: Record<string, any>;
}

interface IOption {
  type: string;
  id : string;
  subtype: string;
  value: string;
}

interface ISignInAdmin {
  email: string;
  password?: string;
}

interface IPlatform {
  type : string;
  id : string | number;
  subtype : string;
  value : string | number;
}

interface PlatformDataContextData {
  platform: Record<string, any>;


}

const PlatformDataContext = createContext<PlatformDataContextData>({} as PlatformDataContextData);

const PlatformDataProvider: React.FC = ({ children }) => {
  
  const [platform, setPlatform] = useState<Record<string,any>>({});
  
  
const load = async () => {

    const platformData = await Axios.get('/config/platform.json');
    const {data} = platformData;
    setPlatform(data || {});
  }

  useEffect(() => {
    load()
  },[])



  

  return (
    <PlatformDataContext.Provider
      value={{
        platform
      }}
    >
      {children}
    </PlatformDataContext.Provider>
  );
};

function usePlatformData(): PlatformDataContextData {
  const context = useContext(PlatformDataContext);

  if (!context) {
    throw new Error('usePlatform must be used within an PlatformProvider');
  }

  return context;
}

export { PlatformDataProvider, usePlatformData };
